import i18n from "locales/i18n";

function formatBoolean(value: boolean): string {
  return value ? i18n.t("yes") : i18n.t("no");
}

export default formatBoolean;
